require('./ctxRadioButton.style.scss');

class CtxRadioButtonController {
    constructor($scope, $element, $timeout) {
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.isRequired = angular.isDefined(this.isRequired);
    }

    $onInit() {
        this.$scope.$watch(() => this.selectValue, selectValue => {
            this.$timeout(() => {
                if (this.$element.find('#radio-' + selectValue).attr('disabled') === 'disabled') {
                    this.selectValue = undefined;
                }
            });
        })
    }

    setValue(newVal) {
        this.selectValue = newVal;
    }

    handleArrow(keyCode) {
        if (this.optionsList.length < 2) return;
        let selectedIndex = this.optionsList.map(v => v.value).indexOf(this.selectValue),
            i = 0,
            firstEl = selectedIndex === 0,
            lastEl = this.optionsList.length - 1 === selectedIndex;

        //arrow up
        if (keyCode === 38 && !firstEl) i = -1;

        //arrow down
        if (keyCode === 40 && !lastEl) i = +1;

        if (i !== 0) {
            this.setValue(this.optionsList[selectedIndex + i].value);
        }
    }
}

const ctxRadioButtonComponent = {
    restrict: 'E',
    controller: CtxRadioButtonController,
    scope: {},
    template: require('./ctxRadioButton.template.html'),
    bindings: {
        isRequired: '<?',
        form: '<',
        selectName: '@',
        selectLabel: '@?',
        placeholder: '@?',
        inputClass: '@?',
        selectValue: '=',
        optionsList: '<',
        isDisabled: '<',
        warningMessage: '<?',
        disabledMessage: '<?',
        optionLabelProperty: '@',
        requiredMessage: '@?',
        iconTooltip: '@',
        labelTooltipText: '@?',
        iconTooltipText: '<'
    }
};

CtxRadioButtonController.$inject = ['$scope', '$element', '$timeout'];

module.exports = ctxRadioButtonComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxRadioButton/ctxRadioButton.component.js